const translationMap = new Map()
    .set('convenience_food', 'Fertiggerichte')
    .set('drinks', 'Getränke')
    .set('foodstuff', 'Nahrungsmittel')
    .set('frozen_goods', 'Tiefkühlware')
    .set('snacks', 'Snacks')
    .set('wine_spirits', 'Wein und Spirituosen')
    .set('canned_dish', 'Dosengerichte')
    .set('soup', 'Suppen')
    .set('alcohol_drinks', "Alkholhaltige Getränke")
    .set('beer', 'Bier')
    .set('beer_mixed_drinks', 'Bier Mischgetränke')
    .set('beer_mixed_drinks_non_alcohol', 'Bier Mischgetränke (Alkoholfrei)')
    .set('juice_smoothies_shots', 'Säfte, Smoothies und Shots')
    .set('non_alcohol_drinks', 'Alkoholfreie Getränke')
    .set('softdrinks', 'Softdrinks')
    .set('water', 'Wasser')
    .set('baking_ingredients', 'Backzutaten')
    .set('noodles_rice_grain', 'Nudeln, Reis und Getreide')
    .set('oil_dressings_sauce', 'Öl, Dressings und Soßen')
    .set('spread', 'Brotaufstrich')
    .set('icecream', 'Speiseeis')
    .set('chocolate', 'Schokolade')
    .set('liqueur', 'Likör')
    .set('mulled_wine', 'Glühwein')
    .set('red_wine', 'Rotwein')
    .set('rosé_wine', 'Rosé')
    .set('white_wine', 'Weißwein')
    .set('sparkling_wine', 'Schaumwein')
    .set('spirit', 'Spirituosen')
    .set('wine_spritzer', 'Weinschorle')
    .set('fruits_vegetables', 'Früchte und Gemüse')
    .set('tobacco', 'Tabak')
    .set('fresh_goods', 'Frische Lebensmittel');

export default translationMap;
